import { getProfessionalAnalyticsApi, getProfessionalListInMonthsApi, getProfessionalListInYearsApi } from 'Constants';
import { Context } from 'Context/Context';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react'
import { RangeBar, rangeLabelOf } from './AdminAnalyticsUI';
import TimeframeHeader from './TimeframeHeader';
import AnalyticProfCard from './AnalyticProfCard';


function ProfessionalsAnalytics() {
    const {makeApiCallFunc} = useContext(Context);
    const [profData, setProfData] = useState(null);
    const [frame, setFrame] = useState("today");
    const [loadProfAnalytics, setLoadProfAnalytics] = useState(true);
    const [xAxisValues, setXAxisValues] = useState([]);
    const [values, setValues] = useState([]);
    const [totalCount, setTotalCount] = useState();
  
  
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(Date.now()),
      endDate: new Date(Date.now()),
      key: 'selection'
    }
  ]);
  const transformResponseForGraph = (data)=> {
    let arr = { "verified" : [], "unverified" : []}
    data.users.map((usr) => {
      if(usr.verified === true)
      {
        arr.verified.push(usr);
      }
      else
      {
        arr.unverified.push(usr);
      }
      
    })
    console.log({...data, ...arr});
    setProfData({...data, ...arr});
    getDatesBetween({...data, ...arr})
  }
  const getDatesBetween = (data) =>{
    const dates = [];
    let values = {
      "users" : [],
      "toVerify" : [],
      "verified" : [],
      "unverified" : []
    };
    let currentDate = moment(dateRange[0]?.startDate);
    const finalDate = moment(dateRange[0]?.endDate);
    const count = {
      "users": data?.users?.length,
      "toVerify" : data?.toVerify?.length,
      "unverified": data?.unverified?.length,
      "verified": data?.verified?.length
    }
    while (currentDate <= finalDate) {
      dates.push(moment(currentDate).format("MM-DD-YYYY"));

      values.users.push(getValues(currentDate, "users", "timestamp", data));
      values.toVerify.push(getValues(currentDate, "toVerify", "updated_at", data));
      values.verified.push(getValues(currentDate, "users", "timestamp", data, true));
      values.unverified.push(getValues(currentDate, "users", "timestamp", data, false));
  
      currentDate = moment(currentDate).add(1, "days");
    }
    setXAxisValues(dates);
    setValues(values);
    setTotalCount(count);
    console.log(values);
    return dates;
  }
  const isMoreThan60Days = () => {
    const date1 = moment(dateRange[0]?.startDate);
    const date2 = moment( dateRange[0]?.endDate);
    const differenceInDays = date2.diff(date1, 'days');

    // Check if the difference is more than 60 days
    const moreThan60DaysApart = differenceInDays > 60;
   
    return moreThan60DaysApart;
  }
  const getValues = (currentDate, arrayName, compareField, data, isVerified) => {
    var count = 0;
    const date2 = moment(currentDate);
    data?.[arrayName]?.map((item) => {
      const date1 = moment(item?.[compareField]);
    
      const areDatesSame = date1.isSame(date2, "day"); // Change "day" to "date" if you want to compare the dates down to the millisecond
      if(areDatesSame && (isVerified === undefined || isVerified === item.verified))
      { count ++;}
    })
  
    return count;
  }
    useEffect(() => {
      const startTime = dateRange[0]?.startDate;
      const endTime = dateRange[0]?.endDate;
      if(isMoreThan60Days())
      {
        const startMonth = startTime.getMonth() + 1; // Adding 1 to get the month in the range 1-12
        const year = startTime.getFullYear();
        const endMonth = endTime.getMonth() + 1;
        const endyear = endTime.getFullYear();
        if(year === endyear)
        {
          makeApiCallFunc(getProfessionalListInMonthsApi,
            {
              startMonth,
              endMonth,
              year
            },
            ({data})=> {
              setProfData(data);
              transformResponseForMonthsGraph(data);
            },
            (data) => console.log(data)
            )
        }
        else
        {
          makeApiCallFunc(getProfessionalListInYearsApi,
            {
              startYear:year,
              endYear: endyear
            },
            ({data})=> {
              setProfData(data);
              transformResponseForMonthsGraph(data);
            },
            (data) => console.log(data)
            )
        }
       
      }
      else
      {
     makeApiCallFunc(getProfessionalAnalyticsApi,
      {
        startTime,
        endTime
      },
      ({data})=> {
        transformResponseForGraph(data);
      },
      (data) => console.log(data)
      )
    }
    }, [loadProfAnalytics])
    const transformResponseForMonthsGraph = (data) => {
      const dates = [];
  
      const values = {
        "users":[],
        "toVerify" : [],
        "verified":[],
        "unverified" : []
      };
      const count = {
        "users": 0,
        "toVerify" : 0,
        "verified":0,
        "unverified" : 0
      }
      data.map((d)=>
      {
        dates.push(Object.entries(d)[0][0]);
        values.users.push(Object.entries(d)[0][1].users);
        values.toVerify.push(Object.entries(d)[0][1].toVerify);
        values.verified.push(Object.entries(d)[0][1].verified);
        values.unverified.push(Object.entries(d)[0][1].unverified);

        count.users = Object.entries(d)[0][1].users + count.users;
        count.toVerify = Object.entries(d)[0][1].toVerify + count.toVerify;
        count.verified = Object.entries(d)[0][1].verified + count.verified;
        count.unverified = Object.entries(d)[0][1].unverified + count.unverified;

  
      })
      setValues(values);
      setXAxisValues(dates);
      setTotalCount(count);
    }
    const isSingleDay = () => {
      const date1 = moment(dateRange[0]?.startDate);
      const date2 = moment( dateRange[0]?.endDate);
  
      // Compare if the two dates are the same
      const areDatesSame = date1.isSame(date2, "date"); // Change "day" to "date" if you want to compare the dates down to the millisecond
      return areDatesSame
    }
    return (
      <div className='w-full font-plexsans'>
        <RangeBar dateRange={dateRange}>
          <TimeframeHeader className='flex items-center' setLoadCaseAnalytics={setLoadProfAnalytics} frame={frame} setFrame={setFrame} setDateRange={setDateRange} dateRange={dateRange}/>
        </RangeBar>
        <AnalyticProfCard
          totalCount={totalCount}
          xAxisValues={xAxisValues}
          values={values}
          rangeLabel={rangeLabelOf(dateRange)}
        />
      </div>
    )
}

export default ProfessionalsAnalytics